import { useContext, useEffect } from "react";
import { Preferences } from "@capacitor/preferences";
import { useConfig } from "../providers/config";
import { useMarketExpressDataState } from "../providers/marketMode";
import { AppContext } from "../providers/Redux/Reducers/AppContext";

const useLocalStorageInit = () => {
  const config = useConfig();
  const { dispatch } = useContext(AppContext); // For Store

  useEffect(() => {
    // For Getting Local Storage Data
    const getLocalStorageData = async () => {
      const storageWishListProducts: any = await Preferences.get({ key: "wishListProducts" });
      if (storageWishListProducts.value != null) {
        dispatch({
          type: "ADD_WISHLIST_PRODUCTS",
          wishListProducts: JSON.parse(storageWishListProducts.value),
          localStorage: true,
        });
      }
    };

    // For Save Default Currency
    const saveDefaultCurrency = () => {
      if (localStorage.appStartFirstTime === undefined) {
        localStorage.currencyDefault = localStorage.currency; //default currency symbol to show in app
        localStorage.currencyCodeDefault = localStorage.currencyCode; //default currency code
        localStorage.currencyPosDefault = localStorage.currencyPos; //default currency position
        localStorage.decimalsDefault = localStorage.decimals; //default currency decimal
        localStorage.appStartFirstTime = "started";
      }
    };

    if (!config.isExpressDeliveryEnabled) {
      useMarketExpressDataState.getState().reset();
    }

    saveDefaultCurrency();
    getLocalStorageData();
  }, [config.isExpressDeliveryEnabled, dispatch]);
};

export default useLocalStorageInit;